import React from 'react';

import { Menu } from 'antd';
import { Header } from 'antd/es/layout/layout';
import { useNavigate } from 'react-router-dom';

const items = [
  {
    key: 'home',
    label: 'Accueil',
  },
  {
    key: 'collections',
    label: 'Collections',
  },
  {
    children: [
      {
        key: 'add:serie',
        label: 'Ajouter une série',
      },
      {
        key: 'add:collection',
        label: 'Ajouter une collection',
      },
      {
        key: 'add:maison',
        label: "Ajouter une maison d'édition",
      },
    ],
    key: 'add',
    label: 'Créer',
  },
  {
    children: [
      {
        key: 'compressStickers',
        label: 'Compresser des images',
      },
      {
        key: 'gptToGdoc',
        label: 'GPT to GDOC',
      },
    ],
    key: 'tools',
    label: 'Outils',
  },
  {
    children: [
      {
        key: 'manageApp',
        label: 'App mobile',
      },
      {
        key: 'manageAccount',
        label: 'Gestion compte',
      },
      {
        key: 'codeCadeau',
        label: 'Codes cadeau',
      },
      {
        key: 'webappCodes',
        label: 'Codes Webapp',
      },
      {
        key: 'serieCodes',
        label: 'Codes série',
      },
    ],
    key: 'manage',
    label: 'Manage',
  },
  {
    children: [
      {
        key: 'statSerie',
        label: 'Série',
      },
    ],
    key: 'stats',
    label: 'Stats',
  },
  {
    children: [
      {
        key: 'reloadClasses',
        label: 'Recharger les classes',
      },
      {
        key: 'transitionAnnee',
        label: "Transition d'année",
      },
    ],
    key: 'edifice',
    label: 'Edifice',
  },
];

const HeaderHome = () => {
  const navigate = useNavigate();

  const onClick = e => {
    console.log('click ', e);
    switch (e.key) {
      case 'manageAccount':
        navigate('/manage/account');
        break;
      case 'codeCadeau':
        navigate('/manage/gift');
        break;
      case 'webappCodes':
        navigate('/manage/code/webapp');
        break;
      case 'serieCodes':
        navigate('/manage/code/serie');
        break;
      case 'manageApp':
        navigate('/manage/app');
        break;
      case 'add:serie':
        navigate('/serie/add');
        break;
      case 'add:collection':
        navigate('/collection/add');
        break;
      case 'add:maison':
        navigate('/maison/add');
        break;
      case 'gptToGdoc':
        navigate('/gpt/gdoc');
        break;
      case 'compressStickers':
        navigate('/tools/stickers');
        break;
      case 'statSerie':
        navigate('/stats/serie');
        break;
      case 'collections':
        navigate('/collection');
        break;
      case 'reloadClasses':
        navigate('/edifice/classes');
        break;
      case 'transitionAnnee':
        navigate('/edifice/transition');
        break;
      default:
        navigate('/');
    }
  };

  return (
    <Header>
      <Menu
        onClick={onClick}
        selectedKeys={[]}
        mode="horizontal"
        items={items}
        style={{ backgroundColor: 'transparent' }}
        theme="dark"
      />
    </Header>
  );
};

export default HeaderHome;
